import TablePage from '@/found/components/table_page';
import Form from './components/index.vue';

export default {
  extends: TablePage,
  name: 'main_list',
  data() {
    return {
      requestType: 'POST',
    };
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('main_list');
  },

  methods: {
    modalClick({ val, row }) {
      console.log(val);
      const { code } = val;
      if (code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = '查看';
        this.openFull();
      }
    },
  },
};
